import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import SoftCardDReco from '../SoftCardDReco/SoftCardDReco';
import styles from './LineCardDReco.module.less';
import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ recommendData, logInfo, info }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    const softIDs = []
    recommendData.apps.slice(0, 4).forEach((soft) => {
      softIDs.push(soft.softID);
    })
    const param2 = {
      source: logInfo.source,
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softids: softIDs.join(', '),
    }
    if (logInfo.source.indexOf('Search') > -1) {
      param2.search_type = logInfo.search_type
      param2.search_word = logInfo.search_word
    }
    dispatch(
      logging({
        category: 'I',
        action: 'DReco',
        label: '',
        param2,
      }),
    );
  }, [dispatch]);

  return (
    <div className={(!info || info.isHiddleName === false) ? styles.search_recommend : styles.search_recommend_simple}>
      {(!info || info.isHiddleName === false) && (<div className={styles.search_recommend_title}>为你推荐</div>)}
      <div className={styles.search_recommend_apps}>
        {recommendData &&
          recommendData.apps &&
          recommendData.apps.length > 4 &&
          recommendData.apps.slice(0, 4).map((soft, j) => (
            <SoftCardDReco soft={soft} logInfo={{ ...logInfo }} key={j} />
          ))
        }
      </div>
    </div>
  )
});
